import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "../../../../components/Menu";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import EmptyState from "../../../../components/EmptyState";
import { formatDate } from "../../../../utils/Helpers";
import emptyPlaceholder from "../../../../assets/images/timesheet-screen/empty-report-placeholder.svg";

const ShiftsAttendanceTable = ({
  list = [],
  meta = {},
  isLoading,
  page,
  onPageChange,
  timeSheet,
  shared,
  lang,
  editDeleteActions = [],
  onEditOrDelete,
}) => {
  if (!isLoading && !list?.length) {
    return (
      <div className="bg-white rounded-4 d-flex justify-content-center align-items-center flex-column my-4">
        <EmptyState
          description={timeSheet.placeholder}
          imgSrc={emptyPlaceholder}
          showActionButton={false}
        />
      </div>
    );
  }

  return (
    <>
      <div className="bg-white rounded-4 mt-2 pb-3">
        <Table
          className="rounded-4"
          headlines={[
            timeSheet.date,
            timeSheet.checkin,
            timeSheet.checkout,
            timeSheet.applicantReport.workingHours,
            timeSheet.monthlyReport.checkoutStatus,
            shared.actions,
          ]}
          hasActions={false}
          hasSizeLimitation={false}
          rows={list?.map((row, i) => (
            <TableRow
              key={i}
              className={`${
                row.is_checked_out_automatically ? "flagged-row" : ""
              }`}
            >
              <TableCell>{row.check_in_readable_date}</TableCell>
              <TableCell>
                {row?.check_in_at
                  ? formatDate(row?.check_in_at, "HH:mm:ss")
                  : "-"}
              </TableCell>
              <TableCell>
                {row?.check_out_at
                  ? formatDate(row?.check_out_at, "HH:mm:ss")
                  : "-"}
              </TableCell>
              <TableCell
                className={`mobile-style ${lang === "ar" && "text-end"}`}
                dir="ltr"
              >
                {row.working_hours}
              </TableCell>
              <TableCell
                className={`mobile-style ${lang === "ar" && "text-end"}`}
                dir="ltr"
              >
                {row.check_out_at && row.is_checked_out_automatically
                  ? timeSheet.monthlyReport.automaticCheckout
                  : row.check_out_at
                  ? timeSheet.monthlyReport.selfCheckout
                  : timeSheet.monthlyReport.checkoutStatusPending}
              </TableCell>
              <TableCell className="mobile-style">
                <Menu
                  options={editDeleteActions}
                  onSelectItem={(option) => onEditOrDelete(option, row)}
                  triggerIcon={<MoreVertIcon />}
                  paperProps={{
                    style: {
                      width: "15ch",
                      color: "#6B778C",
                    },
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        />
      </div>
      <div className="d-flex justify-content-center py-3 mt-4">
        {meta.pages > 1 && (
          <Pagination
            count={meta.pages}
            page={meta.currentPage || page}
            handleChange={(event, newPage) => onPageChange(event, newPage)}
            defaultPage={1}
          />
        )}
      </div>
    </>
  );
};

ShiftsAttendanceTable.propTypes = {
  list: PropTypes.array,
  meta: PropTypes.object,
  isLoading: PropTypes.bool,
  page: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  timeSheet: PropTypes.object.isRequired,
  shared: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  editDeleteActions: PropTypes.array,
  onEditOrDelete: PropTypes.func.isRequired,
};

export default ShiftsAttendanceTable;
